/* globals translation */
/*
 * Toggle menu
*/
function toggle_menu() {
	jQuery('.main-menu-popup').fadeToggle('fast', 'linear').css('display', 'flex');
	jQuery('body').toggleClass('display-menu');
}





/*
 * Toggle search
*/
function toggle_search() {
	jQuery('.search-form-overlay').fadeToggle('fast', 'linear').css('display', 'flex');
	jQuery('body').toggleClass('display-search');
}





/*
 * Read more slide functionality
*/
function readMoreSlider() {
	jQuery('.read-more').click(function(e) {
		jQuery(this).addClass('open');
		jQuery(this).siblings('.read-more-wrapper').addClass('open');
	});
}

function readMoreCategoryDescription() {
	var $p =jQuery('.title-and-cat .title-description .term-description p');
	$p.first().html(function(){
		return $p.map(function(){
			return jQuery(this).html() ;
		}).get().join(' ');
	}).end().filter(':gt(0)').remove();

	const show_char = 230;
	const ellipses = "... ";
	const content = jQuery(".title-and-cat .title-description .term-description").html();

	if ( content ) {
		if (content.length > show_char) {
			const a = content.substr(0, show_char);
			const b = content.substr(show_char - content.length);
			const html = a + "<span class=\'truncated\'>" + ellipses + "<a class=\'read-more\'>" + translation.read_more + "</a></span><span class=\'truncated\' style=\'display:none\'>" + b + "</span>";
			jQuery(".title-and-cat .title-description .term-description").html(html);
		}
		jQuery(".read-more").click(function(e) {
			e.preventDefault();
			jQuery(".title-and-cat .title-description .term-description .truncated").toggle();
		});
	}

}
readMoreCategoryDescription();

function filterTags() {
	const productTags = jQuery('.product-tags .product-tag');
	const disableTags = document.querySelectorAll('.product-tags .product-tag')

	let tags = [];
	productTags.each( function productTag() {

		jQuery( this ).on( 'click', () => {
			[...disableTags].map(tag => tag.classList.add('disabled') );
			const productTag = jQuery( this ).data( 'tag');
			const productCat = jQuery( this ).data( 'cat');

			if ( jQuery(this).hasClass('active') ) {
				tags = jQuery.grep(tags, function(value) {
					return value !== productTag;
				});

				jQuery.ajax({
					type: 'POST',
					url: translation.ajaxurl,
					dataType: 'html',
					data: {
						action: 'filter_products',
						category: productCat,
						tag: tags,
					},
					beforeSend: function() {
						jQuery('#loader').addClass('active');
					},
					success: function(res) {
						jQuery('#loader').removeClass('active');
						jQuery('.archive.tax-products .loop-image-and-text-wrapper').html(res);
						[...disableTags].map(tag => tag.classList.remove('disabled') );
					}
				})
				jQuery( this ).removeClass( 'active' );
			} else {
				tags.push(productTag)
				jQuery( this ).addClass( 'active' );
				jQuery.ajax({
					type: 'POST',
					url: translation.ajaxurl,
					dataType: 'html',
					data: {
						action: 'filter_products',
						category: productCat,
						tag: tags,
					},
					beforeSend: function() {
						jQuery('#loader').addClass('active');
					},
					success: function(res) {
						jQuery('#loader').removeClass('active');
						jQuery('.archive.tax-products .loop-image-and-text-wrapper').html(res);
						[...disableTags].map(tag => tag.classList.remove('disabled') );
					}
				})
			}

		} );
	});
	jQuery('.remove-filters a').click(function() {
		[...disableTags].map(tag => tag.classList.add('disabled') );
		const productCat = jQuery( this ).attr( 'data-cat');
		jQuery.ajax({
			type: 'POST',
			url: translation.ajaxurl,
			dataType: 'html',
			data: {
				action: 'filter_products',
				category: productCat,
				tag: [],
			},
			beforeSend: function() {
				jQuery('#loader').addClass('active');
			},
			success: function(res) {
				tags = [];
				jQuery('#loader').removeClass('active');
				jQuery('.archive.tax-products .loop-image-and-text-wrapper').html(res);
				[...productTags].map(tag => tag.classList.remove('disabled') );
				[...productTags].map(tag => tag.classList.remove('active') );
				[...disableTags].map(tag => tag.classList.remove('disabled') );
			}
		})

	} );
}

/*
 * Menu trigger
*/
jQuery(document).on('click', '.header-icons .menu, .close-menu', toggle_menu );
jQuery(document).on('keyup',function(e) {
	if (e.keyCode === 27 && jQuery('body').hasClass('display-menu')) {
		toggle_menu();
	}
});





/*
 * Menu trigger
*/
jQuery(document).on('click', '.header-icons .search, .close-search', toggle_search );
jQuery(document).on('keyup',function(e) {
	if (e.keyCode === 27 && jQuery('body').hasClass('display-search')) {
		toggle_search();
	}
});






jQuery(document).on('ready', function() {
	jQuery('.owl-carousel').owlCarousel({
		loop: true,
		nav: true,
		responsive:{
			0:{
				items:2,
			},
			700:{
				items:3,
			},
			1000:{
				items:4,
			},
			1600: {
				items:4,
			}
		},
	})
});





jQuery(document).on('ready', function() {
	readMoreSlider();
	readMoreCategoryDescription()
	filterTags();
	//removeFilters();
});



jQuery(window).load(function() {
	jQuery('.flexslider').flexslider({
		multipleKeyboard: true,
		smoothHeight: true,
		pauseOnHover: true,
		slideshowSpeed: 6000,
		controlNav: true,
		directionNav: true,
		prevText: '<span class="dashicons dashicons-arrow-left-alt2"></span>',
		nextText: '<span class="dashicons dashicons-arrow-right-alt2"></span>'
	});
});


jQuery(document).ready(function($) {
	var stickyNavTop = $('.header-categories').offset().top;

	var stickyNav = function() {
		var scrollTop = $(window).scrollTop();

		if (scrollTop > stickyNavTop) {
			$('.header-categories').addClass('sticky');
			$( ".header-icons" ).appendTo( ".menus" );

			$('.header-icons .search img').attr('src',function(i,e) {
				return $(this).attr('src').replace("search-icon.svg", "search-icon-white.svg");
			});

			$('.header-icons .menu img').attr('src',function(i,e) {
				return $(this).attr('src').replace("menu-icon.svg", "menu-icon-white.svg");
			});

			$( ".small-logo img" ).show();
		} else {
			$('.header-categories').removeClass('sticky');
			$( ".header-icons" ).appendTo( ".icons-wrapper" );

			$('.header-icons .search img').attr('src',function(i,e) {
				return $(this).attr('src').replace("search-icon-white.svg", "search-icon.svg");
			});

			$('.header-icons .menu img').attr('src',function(i,e) {
				return $(this).attr('src').replace("menu-icon-white.svg", "menu-icon.svg");
			});

			$( ".small-logo img" ).hide();
		}
	};

	stickyNav();
	// and run it again every time you scroll
	$(window).scroll(function() {
		stickyNav();
	});
});
